import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import App from './App.vue';
import router from './router';
import store from './store/store';
import Router from "vue-router";
//import {Delier} from "@/plugins/delier";
import 'promise-polyfill/src/polyfill';     // enable window.Promise in IE

if( window.location.href.indexOf('localhost') < 0 ) {
    Raven
        .config('https://b3657191f67a4a5da78df223b4aacf25@sentry.ijsfontein.nl/9')
        .addPlugin(RavenVue, Vue)
        .install();
}

Vue.config.productionTip = false;

// Vue.use(Delier);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
